<template>
	<div class="flex flex-wrap items-center gap-2">
		<AppButton
			v-for="section in sections"
			:key="section.type"
			type="button"
			class="flex items-center flex-none gap-1"
			@click="$emit('append', section.type)"
		>
			<AppIcon name="add" />
			{{ section.appendLabel }}
		</AppButton>
	</div>
</template>

<script lang="ts" setup generic="T extends string">
interface Props {
	sections: {
		type: T;
		appendLabel: string;
	}[];
}
defineProps<Props>();
defineEmits<{
	append: [type: T];
}>();
</script>
